import { useEffect, useState, type ReactNode } from 'react';

interface AparecerProps {
  children: ReactNode;
  /** Atraso na cascata, em ms (recomendado: 50 ms entre itens). */
  atraso?: number;
  className?: string;
}

// Entrada em cascata: fade + subir 8 px. Respeita prefers-reduced-motion.
export default function Aparecer({ children, atraso = 0, className = '' }: AparecerProps) {
  const [on, setOn] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setOn(true), 30);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      className={`rel-anima transition-all duration-500 ease-out motion-reduce:transition-none ${
        on ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'
      } ${className}`}
      style={{ transitionDelay: `${atraso}ms` }}
    >
      {children}
    </div>
  );
}